import React, { useState, useEffect } from "react";
import { Row, Col, Button, Typography, Form, Select, Checkbox, Divider } from "antd";
import { ArrowLeftOutlined, SearchOutlined } from "@ant-design/icons";
import { Link } from "react-router-dom";
import moment from "moment";

import api from '../../services/api';
import { useLocation } from "react-router";
import { useStateValue } from '../../state';
import { getEmpresa, getIdUsuario, getLocal } from "../../services/auth";
import { BreadcrumbPage, FormGW, FormularioDinamico } from "../../components";

export default function FiltrosRelatorio() {

    const [{ manutencao }, dispatch] = useStateValue();
    const [tituloRelatorio, setTituloRelatorio] = useState([]);
    const [tipoRelatorio, setTipoRelatorio] = useState("PDF");
    const [imprimirSomenteCorpo, setimprimirSomenteCorpo] = useState(false);
    const [mostrarFiltros, setmostrarFiltros] = useState(true);
    const [formulario] = Form.useForm();
    const [form2] = Form.useForm();
    const location = useLocation();
    const [elementosFormulario, setElementosFormulario] = useState([]);
    const [fileList, setFileList] = useState([]);
    const [carregando, setCarregando] = useState(false);
    const [relStage, setRelStage] = useState();
    const [paginaVoltar, setPaginaVoltar] = useState("");

    function ordenaParametros(a, b) {
        return a.rpj_ordem - b.rpj_ordem;
    }

    function carregarParametros() {
        //carregando(false)
        let relStatetemp;
        if (!!location.state === false)
            relStatetemp = JSON.parse(localStorage.getItem("@GestorWeb-FiltrosRelatorio"));
        else
            relStatetemp = location.state;
        setRelStage(relStatetemp)
        setPaginaVoltar(!!relStatetemp.retorno ? relStatetemp.retorno : "/relatorios")
        setTituloRelatorio(relStatetemp.nomeRelatorio)

        api.get(`RelatorioJasper/BuscarRelatorio/${relStatetemp.id}`).then(
            res => {
                var elementosFormulario = !!res.data.relatorioParametro ? res.data.relatorioParametro : [];
                elementosFormulario.sort(ordenaParametros);
                setElementosFormulario(!!res.data.relatorioParametro ? res.data.relatorioParametro : []);
            }).catch(
                erro =>
                    console.error(erro)
            );

    };


    useEffect(() => carregarParametros(), [!!location.state]);

    function download(dadosBase64, nomeArquivo) {
        //var dadosBase64 = "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"

        const link = document.createElement('a');
        link.href = "data:application/octet-stream;base64," + dadosBase64;
        link.download = nomeArquivo;
        link.click();
    }

    function gerarRelatorio(values) {
        setCarregando(true);
        for (let valor in values) {
            if (!!Date.parse(values[valor]) && typeof values[valor] === "object" && values[valor].toString().length > 30) {
                values[valor] = moment(values[valor]).format("YYYY/MM/DD")
            } else if (typeof values[valor] === "object") {
                values[valor] = values[valor].join(',')
            } else {

            }
        }
        let filtrosSomenteCorpoRelatorio = [{ "nome": "exibirLogo", "valor": false }, { "nome": "exibirEmpresa", "valor": false }, { "nome": "exibirLocal", "valor": false }, { "nome": "exibirData", "valor": false }, { "nome": "exibirHora", "valor": false }, { "nome": "exibirPagina", "valor": false }, { "nome": "exibirCNPJ", "valor": false }, { "nome": "exibirEndereco", "valor": false }, { "nome": "exibirTelefone", "valor": false }, { "nome": "exibirInscricaoEst", "valor": false }, { "nome": "exibirUsuario", "valor": false }, { "nome": "exibirPaginacao", "valor": false }];
        let parametros = [{ nome: "empresaLogado", valor: getEmpresa() }, { nome: "localLogado", valor: getLocal() }, { nome: "usuarioLogado", valor: getIdUsuario() }];
        let filtros = "";
        elementosFormulario.map((elemento) => {
            if (!!values[elemento.rpj_nomeelemento])
                parametros.push({ nome: elemento.rpj_nomeelemento, valor: values[elemento.rpj_nomeelemento] });
            if (!!values[elemento.rpj_nomeelemento]) {
                filtros += (filtros !== "" ? ", " : "") + elemento.rpj_label.replace(":", "") + ":" + (!!document.getElementById(elemento.rpj_nomeelemento) && !!document.getElementById(elemento.rpj_nomeelemento).value ? document.getElementById(elemento.rpj_nomeelemento).value : values[elemento.rpj_nomeelemento])
            }

        })
        if (filtros !== "")
            parametros.push({ nome: "filtros", valor: filtros })

        if (imprimirSomenteCorpo === true && !tipoRelatorio === "PDF") {
            filtrosSomenteCorpoRelatorio.map((elemento) => {
                parametros.push({ nome: elemento.nome, valor: elemento.valor })
            })
        }

        let urlRel = {
            PathRelatorio: relStage.nomeArquivo,
            Parametros: JSON.stringify(parametros),
            Tipo: tipoRelatorio,
            NomeRelatorio: relStage.nomeRelatorio
        }

        api.post(`RelatorioJasper/RetornaDadosRelatorios`, urlRel).then(
            res => {
                if (tipoRelatorio === 'PDF') {
                    var byteCharacters = atob(res.data);
                    var byteNumbers = new Array(byteCharacters.length);
                    for (var i = 0; i < byteCharacters.length; i++) {
                        byteNumbers[i] = byteCharacters.charCodeAt(i);
                    }
                    var byteArray = new Uint8Array(byteNumbers);
                    var file = new Blob([byteArray], { type: 'application/pdf;base64' });
                    var fileURL = URL.createObjectURL(file);
                    window.open(fileURL);
                } else {
                    download(res.data, urlRel.NomeRelatorio + "." + urlRel.Tipo);
                }
            }).catch(
                erro => {
                    console.error(erro);
                    alert('Erro ao gerar Relatório: ' + erro);
                }
            ).finally(
                () => {
                    setCarregando(false);
                }
            );
    };

    function handleUpload() {
        const formData = new FormData();
        fileList.forEach(file => {
            formData.append('files[]', file);
        });

    };
    function handleChange(file) {
        setFileList([...fileList, file]);
    };

    function onRemove(file) {
        const index = fileList.indexOf(file);
        const newFileList = fileList.slice();
        newFileList.splice(index, 1);
        setFileList(newFileList);

    }

    function beforeUpload(file) {
        console.log("beforeUpload=", file)
        setFileList([...fileList, file]);
        return false;
    }

    useEffect(() => console.log({ fileList }), [fileList])

    return (
        <div className="p-10">
            <BreadcrumbPage />
            <Row className="m-t-8">
                <Col span={24}>
                    <Typography.Title level={3} className="m-b-0">
                        <img src={require("../../assets/i-boleto.png").default} alt="Título Página" /> {tituloRelatorio}
                    </Typography.Title>
                    <Divider orientation="left" plain className="m-t-0">
                        Filtre os dados abaixo para gerar o relatório.
                    </Divider>
                </Col>
            </Row>
            <FormGW form={formulario} onFinish={gerarRelatorio} layout="vertical">
                <FormularioDinamico formulario={formulario} parametrosFiltros={elementosFormulario} />
            </FormGW>
            <Form form={form2} layout="vertical">
                <Row gutter={[8, 0]}>
                    <Col xs={24} sm={12} md={6} lg={5} xl={5}>
                        <Form.Item name="tipoRelatorio" label="Tipo de Documento do Relatório">
                            <Select defaultValue="PDF" onChange={(tipo) => setTipoRelatorio(tipo)}>
                                <Select.Option value="PDF">PDF</Select.Option>
                                <Select.Option value="DOC">DOC</Select.Option>
                                <Select.Option value="DOCX">DOCX</Select.Option>
                                <Select.Option value="HTML">HTML</Select.Option>
                                <Select.Option value="XLS">XLS</Select.Option>
                                <Select.Option value="XLSX">XLSX</Select.Option>
                                <Select.Option value="PPT">PPT</Select.Option>
                                <Select.Option value="PPTX">PPTX</Select.Option>
                                <Select.Option value="RTF">RTF</Select.Option>
                                <Select.Option value="CSV">CSV</Select.Option>
                            </Select>
                        </Form.Item>
                    </Col>
                    <Col xs={24} sm={12} md={8} lg={8} xl={8} className="t-mob-573">
                        <Form.Item noStyle shouldUpdate={(prevValues, currentValues) => prevValues.tipoRelatorio !== currentValues.tipoRelatorio}>
                            {({ getFieldValue }) => {
                                let elemento = getFieldValue('tipoRelatorio');
                                if (elemento !== 'PDF' && !!elemento)
                                    return (<Form.Item name="imprimirSomenteCorpo" valuePropName="checked" >
                                        <Checkbox onChange={(value) => setimprimirSomenteCorpo(value.target.checked)}>Imprimir somente corpo do Relatório</Checkbox>
                                    </Form.Item>);
                                else return null;
                            }}
                        </Form.Item>
                    </Col>
                </Row>
            </Form>
            <Row gutter={[8, 8]} justify="end" className="m-t-16">
                <Col>
                    <Link to={{
                        pathname: paginaVoltar,
                        //search: `?id=${record.rel_id}`,
                        //state: { id: record.rel_id }
                    }}>
                        <Button size="middle" icon={<ArrowLeftOutlined />} onClick={() => localStorage.removeItem("@GestorWeb-FiltrosRelatorio")}>Voltar</Button>
                    </Link>
                </Col>
                <Col>
                    <Button type="primary" size="middle" icon={<SearchOutlined />} loading={carregando} onClick={() => formulario.submit()} >Aplicar Filtros</Button>
                </Col>
            </Row>
        </div>
    );
}
